$(document).ready(function () {
  $(".product-slider").each(function () {
    var productCount = $(this).attr("product-count");
    // Initialize the slider only if product count is more than 3
    if (productCount > 3) {
      $(this).slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "100px",
        arrows: true,
        dots: true,
        prevArrow:
          '<button type="button" class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
          {
            breakpoint: 990,
            settings: {
              centerMode: true,
              centerPadding: "80px",
              slidesToShow: 1.5,
            },
          },
          {
            breakpoint: 749,
            settings: {
              centerMode: true,
              centerPadding: "80px",
              slidesToShow: 1,
            },
          },
        ],
      });
    } else {
      $(this).addClass("cstm-display-flex");
    }
  });

  // Function to activate tab and show corresponding product slider
  function activate(element) {
    const handle = element.dataset.collectionHandle;
    console.log("Tab clicked:", handle); // Debugging line

    // Remove active class from all tabs
    $(".tabs .tab").removeClass("active");
    // Add active class to the clicked tab
    $(element).addClass("active");

    // Hide all product sliders
    $(".product-slider").removeClass("active").hide();
    // Show the product slider corresponding to the clicked tab
    $('.product-slider[data-collection-handle="' + handle + '"]')
      .addClass("active")
      .show()
      .slick("setPosition");
  }

  // Handle tab click events
  $(".tabs .tab").on("click", function () {
    activate(this);
  });

  // Trigger click on the first tab initially to display its products
  $(".tabs .tab").first().click();
});
